import { Box, Flex, Text, Avatar, Divider, Tag } from "@chakra-ui/react";
import colors from "core/resources/theme/colors";
import { useHistory } from "react-router-dom";

interface MensagemBoxProps {
  id: string;
  name: string;
  date: string;
  time: string;
  message: string;
  isLast?: boolean;
  novasRespostas?: boolean;
}

function MensagemBox({
  name,
  id,
  date,
  time,
  message,
  isLast = false,
  novasRespostas,
}: MensagemBoxProps) {
  const history = useHistory();

  return (
    <Box mt="32px">
      <Flex>
        <Avatar name={name} mr="13px" />
        <Flex flex={1} flexDir="column">
          <Flex>
            <Flex flex={1}>
              <Text fontSize="14px" fontWeight="bold">
                {name}
              </Text>
            </Flex>

            <Flex>
              <Text pos="relative" top="2px" fontSize="12px" fontWeight="300">
                {date} às {time}
              </Text>
            </Flex>
          </Flex>

          <Box>
            <Box>
              <Text fontSize="12px" fontWeight="300">
                {message}
              </Text>
            </Box>

            <Flex justifyContent="space-between">
              <Text
                mt="4px"
                onClick={() => history.push(`/administracao/mensagens/${id}`)}
                fontSize="12px"
                color={colors.blue500}
                fontWeight="500"
                cursor="pointer"
              >
                Ver mensagem
              </Text>

              {novasRespostas ? (
                <Tag
                  colorScheme="orange"
                  variant="outline"
                  rounded="full"
                  px={3}
                  py={1}
                  mb={1}
                >
                  Nova resposta (s)
                </Tag>
              ) : null}
            </Flex>
          </Box>
        </Flex>
      </Flex>

      {!isLast && <Divider />}
    </Box>
  );
}

export default MensagemBox;
